import { ENDPOINTS } from "../../constant/routes";
import { request } from "../../services/requests";
import type { AdminRole, PageKey } from "../../auth";

export interface AdminAccessPayload {
  display_name: string | null;
  role: AdminRole;
  permissions: PageKey[];
}

/** Grant dashboard access to an existing marketplace user. */
export const createAdminAccess = (payload: AdminAccessPayload & { user_id: string; email: string }, token: string) =>
  request(token).post(`${ENDPOINTS.AUTH}/users`, payload);

export const updateAdminAccess = (adminUserId: string, payload: AdminAccessPayload, token: string) =>
  request(token).put(`${ENDPOINTS.AUTH}/users/${encodeURIComponent(adminUserId.trim())}`, payload);

/** Removes dashboard access only; the marketplace account is unchanged. */
export const revokeAdminAccess = (adminUserId: string, token: string) =>
  request(token).delete(`${ENDPOINTS.AUTH}/users/${encodeURIComponent(adminUserId.trim())}`);
